import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const confirmRequest = async (data: any, drive_id: any) => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/drives/${drive_id}/confirm`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default confirmRequest;
